import { Check } from '@mui/icons-material';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import CButton from '../../components/CButton';
import CModal from '../../components/CModal';
import { CNotificationModalText } from '../../components/CNotificationModalText';
import CPageModule from '../../components/CPageModule';
import HGeneric from '../../helpers/HGeneric';
import { updateStateAttribute } from '../../helpers/helper';
import { type NotificationDTO } from '../../services/SvNotificationServices';

interface Props {
  notification: NotificationDTO;
  onMarkComplete: (notificationID: string) => void;
}

interface State {
  showModal: boolean;
}

export function CNotificationEntry(props: Props) {
  const [state, setState] = useState<State>({ showModal: false });

  const trimmedTitle = props.notification.desc.title.trim();
  const trimmedDetail = props.notification.desc.detail.trim();
  const createdTime = HGeneric.formatString(props.notification.createdTs, {
    in: 'tzTimestamp',
    out: 'localeTimeString'
  });

  const contentComponent = (
    <div className={'flex flex-col gap-0 flex-grow normal-case text-left text-base font-normal'}>
      <p className={'text-xs mb-2'}> {createdTime} </p>
      {trimmedTitle && <p className={'font-bold -mt-1'}>{trimmedTitle}</p>}
      {trimmedDetail && <p className={'text-sm'}>{trimmedDetail}</p>}
    </div>
  );

  const actionsComponent = (
    <div className={'flex items-stretch'}>
      {!props.notification.url && (
        <CButton
          // style={{ aspectRatio: 1 }}
          icons={{ start: <Check /> }}
          onClick={() => {
            props.onMarkComplete(props.notification.id);
          }}
        />
      )}
    </div>
  );

  const contentButtonComponent = () => {
    if (props.notification.modalText) {
      return (
        <CButton
          onClick={() => {
            updateStateAttribute<State>({ showModal: true }, setState);
          }}
        >
          {contentComponent}
        </CButton>
      );
    }
    if (props.notification.url) {
      return (
        <Link to={props.notification.url} className={'flex flex-col'} style={{ color: 'inherit' }}>
          <CButton>{contentComponent}</CButton>
        </Link>
      );
    }
    return <div className={'px-4 py-2'}>{contentComponent}</div>;
  };

  return (
    <>
      <div className={'w-full flex gap-4 rounded-lg'}>
        <div className={'flex w-full flex-col'}>{contentButtonComponent()}</div>
        {!props.notification.url && actionsComponent}
      </div>
      <CModal
        open={state.showModal}
        onClose={() => {
          updateStateAttribute<State>({ showModal: false }, setState);
        }}
      >
        <CPageModule fullWidth style={{ paddingTop: 0, paddingBottom: 0 }}>
          <h3>{props.notification?.desc.title}</h3>
          <CNotificationModalText text={props.notification?.modalText} />
        </CPageModule>
      </CModal>
    </>
  );
}
